import { render, staticRenderFns } from "./livePromote.vue?vue&type=template&id=301c1683&scoped=true&"
import script from "./livePromote.vue?vue&type=script&lang=js&"
export * from "./livePromote.vue?vue&type=script&lang=js&"
import style0 from "./livePromote.vue?vue&type=style&index=0&id=301c1683&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301c1683",
  null
  
)

export default component.exports